import { render, staticRenderFns } from "./investmentPenetration.vue?vue&type=template&id=c20e6296&scoped=true"
import script from "./investmentPenetration.vue?vue&type=script&lang=js"
export * from "./investmentPenetration.vue?vue&type=script&lang=js"
import style0 from "./investmentPenetration.vue?vue&type=style&index=0&id=c20e6296&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20e6296",
  null
  
)

export default component.exports